export function ingredientsSelectedCount(ingredientgroup) {
  let count = 0;
  ingredientgroup.ingredients.forEach(ing => {
    count += ing.count;
  });
  return count;
}

export function selectionValid(ingredientgroup) {
  let count = ingredientsSelectedCount(ingredientgroup);
  let min_valid = true;
  let max_valid = true;
  if (ingredientgroup.min_count > 0) {
    console.log("ingredientgroup.min_count > 0");
    min_valid = ingredientgroup.min_count <= count;
  }
  if (ingredientgroup.max_count > 0) {
    console.log("ingredientgroup.max_count > 0");
    max_valid = ingredientgroup.max_count >= count;
  }
  return min_valid && max_valid;
}

export function getFirstIngredientGroupId(igs) {
  if (igs && igs.length > 0) {
    return igs[0].id;
  } else {
    return "";
  }
}

export function setBreadcrumbData(
  ingredientGroups,
  currentIngredientGroupId,
  limited = true
) {
  const filteredGroups = filterIngredientGroups(ingredientGroups, limited);
  return mapToBreadcrumbItems(filteredGroups, currentIngredientGroupId);
}

function filterIngredientGroups(groups, limited) {
  return groups.filter(group => {
    // if limited=true additionally filter groups by "offer_options_to_user".
    const isNotDefault = group.name !== "default";
    return limited ? isNotDefault && group.offer_options_to_user : isNotDefault;
  });
}

function mapToBreadcrumbItems(groups, currentGroupId) {
  return groups.map((group, index) => ({
    id: group.id,
    index,
    name: group.name,
    active: group.id === currentGroupId
  }));
}

export function isFirstBreadcrumbItemActive(breadcrumbData) {
  if (breadcrumbData && breadcrumbData.length > 0) {
    return breadcrumbData[0].active;
  } else {
    return false;
  }
}

export function getPrevious(breadcrumbData, currentIngredientGroupId) {
  if (!breadcrumbData && !currentIngredientGroupId) {
    console.log("Missing parameters.");
    return;
  }
  let currentBreadcrumbItem = breadcrumbData.find(
    breadcrumbItem => breadcrumbItem.id === currentIngredientGroupId
  );
  if (!currentBreadcrumbItem) {
    console.log(
      "BreadcrumbItem not found for id = " + currentIngredientGroupId
    );
    return;
  }
  if (!(currentBreadcrumbItem.index > 0)) {
    console.log("Invalid index = " + currentBreadcrumbItem.index);
    return;
  }
  let previousIndex = currentBreadcrumbItem.index - 1;
  console.log("previousIndex = " + previousIndex);

  let previousBreadcrumbItem = breadcrumbData.find(
    breadcrumbItem => breadcrumbItem.index === previousIndex
  );
  if (!previousBreadcrumbItem) {
    console.log("BreadcrumbItem not found for index = " + previousIndex);
  }
  //console.log("previousBreadcrumbItem = " + JSON.stringify(previousBreadcrumbItem, null, 2));

  return previousBreadcrumbItem;
}
